import { SITE_VARIABLES } from '../../../../common/styles/variables';
import {
  DISCOVERY_SHOW_NEXT_VIDEO_IN_TOTAL_SECONDS,
  DISCOVERY_SHOW_SKIPPABLE_CONTENT_IN_TOTAL_SECONDS,
} from '../../discoveryPlugin.constants';
import { flexColumnCenterCenter } from '../../../../common/styles/flex';

interface StylesObject {
  countdownLoaderContainerStyle: { [key: string]: any };
  loaderStyle: { [key: string]: any };
  countdownLoaderStyle: { [key: string]: any };
}

interface LoaderStyleObject {
  width: string;
  height: string;
  left: string;
  backgroundColor: string;
  transition: string;
  borderRadius: string;
  smallSize: { [key: string]: any };
}

const countdownLoaderContainer = {
  ...flexColumnCenterCenter,
  position: 'absolute',
  bottom: '0px',
  width: '153px',
  height: '18px',
  backdropFilter: 'blur(3px)',
  webkitBackdropFilter: 'blur(3px)',
  backgroundColor: SITE_VARIABLES.COLORS.TRANSPARENT_30_OPACITY,
  smallSize: {
    width: '52px',
    height: '7px',
    borderRadius: `0px 0px 0px ${SITE_VARIABLES.BORDER_RADIUS.TINY}`,
  },
};

const loader = {
  width: '135px',
  height: '2px',
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.SMALL,
  backgroundColor: SITE_VARIABLES.COLORS.GRAY_TRANSPARENT,
  smallSize: {
    width: '49px',
    height: '1px',
  },
};

const getCountdownLoader = (countdownTime: number, isCountDownTimeLonger: boolean): LoaderStyleObject => {
  const totalTime = isCountDownTimeLonger ? DISCOVERY_SHOW_SKIPPABLE_CONTENT_IN_TOTAL_SECONDS : DISCOVERY_SHOW_NEXT_VIDEO_IN_TOTAL_SECONDS;
  return ({
    width: `${(countdownTime / totalTime) * 100}%`,
    height: '2px',
    left: '0',
    backgroundColor: SITE_VARIABLES.COLORS.WHITE,
    transition: 'width 0.25s linear',
    borderRadius: SITE_VARIABLES.BORDER_RADIUS.SMALL,
    smallSize: {
      height: '1px',
    },
  });
};

export const getCountdownLoaderStyleObject = (countdownTime: number, isCountDownTimeLonger: boolean, smallNextVideo: boolean): StylesObject => {
  const countdownLoader = getCountdownLoader(countdownTime, isCountDownTimeLonger);
  return ({
    countdownLoaderContainerStyle: [
      countdownLoaderContainer,
      smallNextVideo && countdownLoaderContainer.smallSize,
    ],
    loaderStyle: [
      loader,
      smallNextVideo && loader.smallSize,
    ],
    countdownLoaderStyle: [
      countdownLoader,
      smallNextVideo && countdownLoader.smallSize,
    ],
  });
};
